<div class="product-form" style="display: block;">
  <form *ngIf="propertyForm" id="property-form" [formGroup]="propertyForm">
    <div class="columns is-mobile">
      <div class="column is-two-third-tablet is-12-mobile">
        <div class="inputfield">
          <input formControlName="name" name="name" type="text" class="border-input" placeholder="Objektname (optional)"
                 [ngClass]="{'has-error': hasError(propertyForm.get('name'))}"/>
          <small *ngIf="propertyForm.get('name').hasError('maxlength') && propertyForm.get('name').touched"
                 style="color: red; font-size: 10px;">
            Maximale Zeichenanzahl überschritten
          </small>
        </div>

        <div class="columns is-mobile">
          <div class="column">
            <div class="columns is-variable is-mobile">
              <div class="column">
                <div class="inputfield">
                  <input formControlName="street" name="street" type="text" class="border-input mb-0"
                         placeholder="Straße" [ngClass]="{'has-error': hasError(propertyForm.get('street'))}"/>

                  <!-- Fehlernachricht für zu viele Zeichen -->
                  <small *ngIf="propertyForm.get('street').hasError('maxlength') && propertyForm.get('street').touched"
                         style="color: red; font-size: 10px;">
                    Maximale Zeichenanzahl überschritten
                  </small>
                </div>
              </div>
              <div class="column  is-3 " style="width: 30%">
                <div class="inputfield">
                  <input formControlName="house_number" type="text" name="house_number" class="border-input"
                         placeholder="Nr" [ngClass]="{'has-error': hasError(propertyForm.get('house_number'))}"/>
                   <small *ngIf="propertyForm.get('house_number').hasError('maxlength') && propertyForm.get('house_number').touched"
                         style="color: red; font-size: 10px;">
                    Maximale Zeichenanzahl überschritten
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="columns is-variable is-1 is-mobile">
              <div class="column is-4">
                <div class="inputfield">
                  <input formControlName="zip" name="zip" type="text" class="border-input "
                         placeholder="PLZ" [ngClass]="{'has-error': hasError(propertyForm.get('zip'))}"/>
                </div>
              </div>
              <div class="column is-8">
                <div class="inputfield">
                  <input formControlName="town" name="town" type="text" class="border-input"
                         placeholder="Stadt" [ngClass]="{'has-error': hasError(propertyForm.get('town'))}"/>
                  <small *ngIf="propertyForm.get('town').hasError('maxlength') && propertyForm.get('town').touched"
                         style="color: red; font-size: 10px;">
                    Maximale Zeichenanzahl überschritten
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="additionalData" >
      <div *ngIf="!isOwnerResearch; else owner">
        <!--div class="column is-6-tablet is-5-desktop is-12-mobile floors-wrapper" style="padding-left: 0">

            <input *ngIf="isTaxProfile()" formControlName="taxNumber" name="taxNumber" type="text"
                   class="border-input"
                   placeholder="Grundsteuernummer" [ngClass]="{'has-error': hasError(propertyForm?.get('taxNumber'))}"/>
        </div -->
          <div class="columns is-mobile" style="flex-wrap: wrap; margin-bottom: 15px" formArrayName="landregisterfolios">
            <div *ngFor="let landregisterfolio of getFolios(propertyForm); let i = index"
                 class="column floors-wrapper" [formGroupName]="i" [ngClass]="(shouldDisplayFolioNumber)?'is-6-tablet is-6-desktop is-12-mobile':'is-12'">
              <div class="columns is-mobile">
                <div *ngIf="shouldDisplayFolioNumber" class="column is-5-tablet is-5-desktop is-6-mobile">
                  <div class="inputfield">
                    <input formControlName="number" type="text"
                           class="border-input"
                           placeholder="Grundbuchblatt" [ngClass]="{'has-error': hasError(landregisterfolio?.get('number'))}"/>
                    <small *ngIf="landregisterfolio?.get('number').hasError('maxlength') && landregisterfolio?.get('number').touched"
                           style="color: red; font-size: 10px;">
                      Maximale Zeichenanzahl überschritten
                    </small>
                  </div>
                </div>
                <div class="column is-6-tablet is-5-desktop is-5-mobile">
                  <div class="inputfield">
                    <input formControlName="gemarkung" type="text"
                           class="border-input" placeholder="Gemarkung" [ngClass]="{'has-error': hasError(landregisterfolio?.get('gemarkung'))}"/>
                    <small *ngIf="landregisterfolio?.get('gemarkung').hasError('maxlength')"
                           style="color: red; font-size: 10px;">
                      Maximale Zeichenanzahl überschritten
                    </small>
                  </div>
                </div>
                <div class="column is-1-tablet is-1-desktop is-1-mobile">
                  <button *ngIf="i != 0 && !disabled" class="button fs-del-button is-white" type="submit" (click)="deleteFolio(i)"
                          style="margin: 0; margin-bottom: 0;padding: 0;margin-top: 5px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                         viewBox="0 0 8 8">
                      <defs>
                        <style>.a {
                          fill: #e87c7f;
                        }</style>
                      </defs>
                      <path style="fill: red;"
                            d="M4,4.727.727,8,0,7.273,3.273,4,0,.727.727,0,4,3.273,7.273,0,8,.727,4.727,4,8,7.273,7.273,8Z"/>
                    </svg>
                  </button>
                </div>
              </div>
              <div formArrayName="flure">
                <div *ngFor="let flur of getFlure(landregisterfolio); let flurI = index"
                     class="columns is-mobile" [formGroupName]="flurI">
                  <div class="column is-4-tablet is-4-desktop is-6-mobile">
                    <div class="inputfield">
                      <div style="display:flex;flex-direction:row;">
                        <input formControlName="number" type="text" class="border-input" placeholder="Flur (falls vorhanden)" style="flex-grow:2; padding-right: 20px;"
                               name="flur"  />
                        <button *ngIf="flurI != 0 && !disabled" class="button fs-del-button is-white" (click)="deleteFlur(i, flurI)"
                                type="submit"
                                style="margin: 0;padding: 0;margin-top: 7px;left: 1px;background-color: rgba(0,0,0,0.0); margin-left: -20px">
                          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8"
                               viewBox="0 0 8 8">
                            <defs>
                              <style>.a {
                                fill: #e87c7f;
                              }</style>
                            </defs>
                            <path style="fill: red;"
                                  d="M4,4.727.727,8,0,7.273,3.273,4,0,.727.727,0,4,3.273,7.273,0,8,.727,4.727,4,8,7.273,7.273,8Z"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="column is-8-tablet is-8-desktop is-6-mobile">
                    <div class="columns is-mobile" style="flex-wrap: wrap; width: 100%">
                      <div formArrayName="flurstuecke"
                           *ngFor="let flurstueck of getFlurstuecke(flur);let fsI = index" class="column is-4">
                        <div  style="display:flex;flex-direction:row;" [formGroupName]="fsI">
                          <input formControlName="number" type="text" class="border-input" placeholder="Flstk"
                                 name="flurstueck" [ngClass]="{'has-error': hasError(flurstueck?.get('number'))}" style="padding-right: 20px;"/>
                          <button *ngIf="fsI != 0 && !disabled" class="button fs-del-button is-white"
                                  (click)="deleteFlurstueck(i, flurI, fsI)"
                                  type="submit"
                                  style="margin: 0;padding: 0;margin-top: 7px; left: 1px; background-color: rgba(0,0,0,0.0);margin-left: -20px">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8"
                                 height="8"
                                 viewBox="0 0 8 8">
                              <defs>
                                <style>.a {
                                  fill: #e87c7f;
                                }</style>
                              </defs>
                              <path style="fill: red;"
                                    d="M4,4.727.727,8,0,7.273,3.273,4,0,.727.727,0,4,3.273,7.273,0,8,.727,4.727,4,8,7.273,7.273,8Z"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div class="column is-3" style="display: flex; align-items: center; justify-content: center">
                        <button *ngIf="!disabled" (click)="addFlurstueck(i, flurI)" class="button fs-button is-white"
                                type="submit" style="margin-left: 0;">
                                              <span class="icon is-small">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="15.989" height="15.989" viewBox="0 0 15.989 15.989">
                                                  <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M14.846,8.531H9.707V3.392A1.142,1.142,0,0,0,8.565,2.25H7.423A1.142,1.142,0,0,0,6.281,3.392V8.531H1.142A1.142,1.142,0,0,0,0,9.673v1.142a1.142,1.142,0,0,0,1.142,1.142H6.281V17.1a1.142,1.142,0,0,0,1.142,1.142H8.565A1.142,1.142,0,0,0,9.707,17.1V11.957h5.139a1.142,1.142,0,0,0,1.142-1.142V9.673A1.142,1.142,0,0,0,14.846,8.531Z" transform="translate(0 -2.25)" fill="#707070"/>
                                                </svg>
                                                </span>
                          <span>
                                                Flstk.
                                              </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <button *ngIf="!disabled" (click)="this.addFlur(i)" class=" fl-button button is-white"
                        type="submit">
                                  <span class="icon is-small">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15.989" height="15.989" viewBox="0 0 15.989 15.989">
                                      <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M14.846,8.531H9.707V3.392A1.142,1.142,0,0,0,8.565,2.25H7.423A1.142,1.142,0,0,0,6.281,3.392V8.531H1.142A1.142,1.142,0,0,0,0,9.673v1.142a1.142,1.142,0,0,0,1.142,1.142H6.281V17.1a1.142,1.142,0,0,0,1.142,1.142H8.565A1.142,1.142,0,0,0,9.707,17.1V11.957h5.139a1.142,1.142,0,0,0,1.142-1.142V9.673A1.142,1.142,0,0,0,14.846,8.531Z" transform="translate(0 -2.25)" fill="#707070"/>
                                    </svg>
                                  </span>
                  <span>
                                    Flur
                                  </span>
                </button>
              </div>
            </div>

            <div *ngIf="shouldDisplayFolioNumber" class="column is-two-third-tablet is-12-mobile add-button-wrapper">
              <button *ngIf="!disabled" (click)="addFolio()"
                      class="gb-button button is-white" type="submit"
                      style="text-align: left; vertical-align: top; margin-left: 0">
                    <span class="icon is-small">
                      <svg xmlns="http://www.w3.org/2000/svg" width="15.989" height="15.989" viewBox="0 0 15.989 15.989">
                        <path id="Icon_awesome-plus" data-name="Icon awesome-plus" d="M14.846,8.531H9.707V3.392A1.142,1.142,0,0,0,8.565,2.25H7.423A1.142,1.142,0,0,0,6.281,3.392V8.531H1.142A1.142,1.142,0,0,0,0,9.673v1.142a1.142,1.142,0,0,0,1.142,1.142H6.281V17.1a1.142,1.142,0,0,0,1.142,1.142H8.565A1.142,1.142,0,0,0,9.707,17.1V11.957h5.139a1.142,1.142,0,0,0,1.142-1.142V9.673A1.142,1.142,0,0,0,14.846,8.531Z" transform="translate(0 -2.25)" fill="#707070"/>
                      </svg>
                    </span>
                <span>
                    Grundbuchblatt
                </span>
              </button>
            </div>
          </div>
      </div>
    </div>


    <div *ngIf="shouldHaveLandregisterValidators" [ngClass]="{'is-hidden': !showCheckbox}" class="promoted-checkbox">

      <input id="tmp" type="checkbox" class="promoted-input-checkbox" formControlName="dataResearch"/>

      <label for="tmp" [ngClass]="mobile ? 'label-mobile custom-checkbox-label' : 'custom-checkbox-label'">

        <!-- Explicit checkbox icon -->
        <img class="checkbox-icon"
             [src]="propertyForm.get('dataResearch')?.value? 'assets/images/checkbox/checked.svg': 'assets/images/checkbox/unchecked.svg'"
             alt="Checkbox icon"/>

        <span style="font-size: 18px;">
          Ich kenne die Grundstücksdaten nicht.
          <ng-container *ngIf="!isOwnerResearch">
            Ich habe nur Adresse und Eigentümer zur Hand.
          </ng-container>
          Bitte recherchieren Sie gegen einen Aufpreis
          <span *ngIf="researchAmount">
            in Höhe von {{ researchAmount | currency: 'EUR' }}
          </span>
          für mich.
        </span>
      </label>
    </div>
  </form>
</div>



<ng-template  #owner>

  <ng-container *ngIf="!propertyForm.value['dataResearch'] || !property.dataResearch">
    <form [formGroup]="ownerForm">
      <div class="columns">
        <!-- Gemarkung Field -->
        <div class="column is-3">
          <div class="inputfield">
            <input formControlName="gemarkung" type="text" class="border-input" placeholder="Gemarkung" [ngClass]="{'has-error': fieldIsInvalid('gemarkung')}"/>
          </div>
        </div>

        <div class="column is-2" >
          <div class="inputfield">
            <div style="display:flex;flex-direction:row;">

              <input formControlName="flur" type="text" class="border-input" placeholder="Flur (falls vorhanden)" style="flex-grow:2; padding-right: 20px;"
                     name="flur"  [ngClass]="{'has-error': fieldIsInvalid('flur')}"/>
            </div>
          </div>
        </div>

        <div class="column is-2">
          <div class="inputfield">
            <div style="display:flex;flex-direction:row;">
              <input formControlName="flstk" type="text" class="border-input" placeholder="Flstk"
                     name="flstk"  [ngClass]="{'has-error': fieldIsInvalid('flstk')}" style="padding-right: 20px;"/>
            </div>
          </div>
        </div>

      </div>
    </form>
  </ng-container>
</ng-template>

